export const NOTIFICATION_TYPE = {
  CONTACT_WITHDRAWAL: 'CONTACT_WITHDRAWAL',
}

export const NOTIFICATION_DEFAULT_CATEGORIES = {
  ALL: 'ALL',
  UNREAD: 'UNREAD',
}

export const NOTIFICATION_DEFAULT_CATEGORIES_LABEL = {
  [NOTIFICATION_DEFAULT_CATEGORIES.ALL]: 'Todas',
  [NOTIFICATION_DEFAULT_CATEGORIES.UNREAD]: 'Não lidas',
}

export const EMPTY_NOTIFICATIONS_MESSAGE = 'Você não possui novas mensagens.'

export const NOTIFICATION_CTA_DEFAULT = 'Ok, entendi!'
